var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSorry = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87.584,
    height: 87.525,
    viewBox: "0 0 87.584 87.525",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_sad_1565264_000000",
    transform: "translate(-1.985 -1.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M45.761,2A43.708,43.708,0,0,0,7.889,67.643l-5.7,17.076A3.645,3.645,0,0,0,6.8,89.331l17.076-5.7A43.762,43.762,0,1,0,45.76,2Zm0,80.23a36.347,36.347,0,0,1-19.467-5.67,3.622,3.622,0,0,0-1.948-.566,3.512,3.512,0,0,0-1.15.192L11.407,80.115l3.928-11.788a3.63,3.63,0,0,0-.374-3.1,36.47,36.47,0,1,1,30.8,17Z",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M32.94,37.294a3.648,3.648,0,0,1,3.647,3.647,3.647,3.647,0,1,0,7.294,0A10.94,10.94,0,1,0,22,40.94a3.647,3.647,0,1,0,7.294,0A3.645,3.645,0,0,1,32.94,37.294Z",
    transform: "translate(-1.767 -2.472)",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M64.94,30A10.939,10.939,0,0,0,54,40.94a3.647,3.647,0,1,0,7.294,0,3.647,3.647,0,0,1,7.294,0,3.647,3.647,0,1,0,7.294,0A10.939,10.939,0,0,0,64.94,30Z",
    transform: "translate(-4.593 -2.472)",
    fill: "#5636d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M63.255,64.223a21.245,21.245,0,0,0-30.086,0l-2.144,2.133v0a3.648,3.648,0,0,0,5.16,5.157l2.133-2.144v0a14.317,14.317,0,0,1,19.748,0L60.2,71.521v0a3.648,3.648,0,0,0,5.16-5.157Z",
    transform: "translate(-2.47 -4.943)",
    fill: "#5636d0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSorry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sorry.807bc332.svg";
export { ForwardRef as ReactComponent };